/**
 * Tier B SHOP projects (shop-{slug}) — catalog SEO SSOT is SHOP admin, not App /admin/seo.
 * Platform App /admin/seo must not mix storefront SEO (vde76 etc.) into platform contour.
 * @see FRONSYSTEM/cache/seo/SHOP_CORE_FIELD_OWNERSHIP.csv
 * @see SEO/18_SHOP_SEO_MAXIMUM_PROVISION_AND_AUTOFILL.md
 */

export const SHOP_SEO_PROJECT_SLUG_PREFIX = 'shop-';

export const SHOP_SEO_ADMIN_SETTINGS_PATH = '/admin/dashboard/settings/seo';

export function isShopHybridSeoProject(projectSlug) {
  const slug = String(projectSlug || '').trim().toLowerCase();
  return slug.startsWith(SHOP_SEO_PROJECT_SLUG_PREFIX) && slug.length > SHOP_SEO_PROJECT_SLUG_PREFIX.length;
}

/**
 * Storefront / shop-admin host — not platform App SEO.
 * @param {{ project_slug?: string, domain?: string, base_url?: string }} project
 */
export function isStorefrontSeoProject(project) {
  if (!project) return false;
  if (isShopHybridSeoProject(project.project_slug)) return true;
  const domain = String(project.domain || '')
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//i, '')
    .split('/')[0];
  if (domain.endsWith('.shop.markbase.ru') || domain === 'shop.markbase.ru') return true;
  try {
    const host = new URL(String(project.base_url || '').trim()).hostname.toLowerCase();
    if (host.endsWith('.shop.markbase.ru') || host === 'shop.markbase.ru') return true;
  } catch {
    /* ignore */
  }
  return false;
}

/** Platform contour for App /admin/seo (excludes storefront shop-* projects). */
export function filterPlatformSeoProjects(projects) {
  return (Array.isArray(projects) ? projects : []).filter((p) => !isStorefrontSeoProject(p));
}

/**
 * @param {{ project_slug?: string, domain?: string, base_url?: string }} project
 * @returns {string|null}
 */
export function resolveShopSeoAdminSettingsUrl(project) {
  if (!project || !isShopHybridSeoProject(project.project_slug)) {
    return null;
  }
  const rawBase = String(project.base_url || '').trim();
  const rawDomain = String(project.domain || '').trim();
  let origin = '';
  if (rawBase) {
    try {
      origin = new URL(rawBase).origin;
    } catch {
      origin = '';
    }
  }
  if (!origin && rawDomain) {
    const host = rawDomain.replace(/^https?:\/\//i, '').replace(/\/+$/, '');
    origin = `https://${host}`;
  }
  if (!origin) {
    const shopSlug = String(project.project_slug || '')
      .trim()
      .toLowerCase()
      .slice(SHOP_SEO_PROJECT_SLUG_PREFIX.length);
    if (shopSlug) {
      origin = `https://${shopSlug}.shop.markbase.ru`;
    }
  }
  if (!origin) return null;
  return `${origin.replace(/\/+$/, '')}${SHOP_SEO_ADMIN_SETTINGS_PATH}`;
}
